<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <Invira-user-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import InviraUserCrud from "./InviraUserCrud";
    export default {
        name: "InviraUserManagementPage",
        components: {InviraUserCrud}
    }
</script>

<style scoped>

</style>

